import { helper } from './helper';
import Vue from 'vue';

const data_url = {
  data: process.env.VUE_APP_CDN_PATH + 'koreantk_v2_encoded_data.json',
  dict: process.env.VUE_APP_CDN_PATH + 'koreantk_v2_dict.json',
  ridx: process.env.VUE_APP_CDN_PATH + 'koreantk_v2_ridx.json',
  net: process.env.VUE_APP_CDN_PATH + 'koreantk_v2_network.json',
};

export const EventBus = new Vue({
  data() {
    return {
      formulaList: null,
      formulaIdx: [],
      dataDict: null,
      dataRidx: null,
      dataNet: null,
      dataReady: false,
    };
  },
  created() {
    helper.log('EventBus is created');
    helper.log(process.env);
    helper.log(data_url);

    const reqData = axios.get(data_url.data);
    const reqDict = axios.get(data_url.dict);
    const reqRidx = axios.get(data_url.ridx);
    const reqNet = axios.get(data_url.net);

    Promise.all([reqData, reqDict, reqRidx, reqNet])
      .then(res => {
        this.formulaList = helper.deepFreeze(res[0].data);
        this.dataDict = helper.deepFreeze(res[1].data);
        this.dataRidx = helper.deepFreeze(res[2].data);
        this.dataNet = helper.deepFreeze(res[3].data);

        this.formulaIdx = helper.deepFreeze([
          ...Array(res[0].data.length).keys(),
        ]);
        helper.log('App Data All Green');
        this.appDataReady();
      })
      .catch(errors => {
        alert('Failed to fetch app data !!!');
      });
  },
  methods: {
    appDataReady() {
      helper.log('EventBus emited event');
      this.dataReady = true;
      this.$emit('appDataReady', {
        formulaList: this.formulaList,
        formulaIdx: this.formulaIdx,
        dataDict: this.dataDict,
        dataRidx: this.dataRidx,
        dataNet: this.dataNet,
      });
    },
  },
});

// [Vue.JS] 대용량 데이터의 처리 방법과 성능 최적화 방법 (Vue.js Performance)
// https://kdydesign.github.io/2019/04/10/vuejs-performance.html#introduction
// Object.freeze() 사용
